module.exports = __webpack_public_path__ + "img/bg_top.dc3eda38.svg";